import { gql } from '@apollo/client';

export const GET_MAP_SESSION = gql`
  query GetMapSession {
    mapSession {
      id
      userId
      hasCompletedOnboarding
      hasCompletedOnboardingPlanView
      mapData
      lastViewed
      createdAt
      updatedAt
    }
  }
`;
